import { gql } from "@apollo/client";

export const typeDef = gql`
  type Attributes {
    name: String
    id: Int
  }
  type GenreAttributesResult {
    attributes: [Attributes]
  }
  type Query {
    genreAttributes(ids: [Int]): GenreAttributesResult
  }
`;

export const resolvers = {
  Query: {
    genreAttributes: async (_parent, args, { dataSources }) => {
      const res = await dataSources.attributes.genreAttributes(args);
      return res;
    },
  },
};
